import type { ReactNode } from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/Tooltip'

// Wraps a button; when it is disabled, hovering shows the reason.
export default function DisabledHint({ reason, children }: { reason: string | null; children: ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild><span>{children}</span></TooltipTrigger>
      {reason && <TooltipContent>{reason}</TooltipContent>}
    </Tooltip>
  )
}
